var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMbRentLogoEinzeiligNeg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 252.6 20.73",
    style: {
      enableBackground: "new 0 0 252.6 20.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000093148438151473521800000009198044409009727415_);fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_00000093148438151473521800000009198044409009727415_);fill:#1DA4E4;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 252.6,
    height: 20.73
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147922539556591950790000012222324661796826790_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#FFFFFF"
    },
    d: "M23.25,19.71v0.69 c-2.22-0.15-2.58-0.18-3.81-0.18H19.2c-0.99,0-2.01,0.06-3.84,0.18v-0.69c2.13-0.18,2.52-0.42,2.43-2.46L17.25,2.79L10.8,19.95 h-0.48L3.93,2.76l-0.54,14.4c-0.09,2.22,0.39,2.37,2.34,2.55v0.69c-1.17-0.09-2.22-0.18-2.88-0.18c-0.87,0-1.8,0.09-2.85,0.18 v-0.69c2.04-0.18,2.43-0.42,2.52-2.52L3.03,3.36c0.09-2.04-0.3-2.28-2.19-2.43V0.24c1.29,0.09,2.13,0.15,2.94,0.15 c0.78,0,1.5-0.03,2.43-0.09l5.43,14.88L17.28,0.3c0.75,0.06,1.44,0.09,2.22,0.09c0.69,0,1.56-0.06,2.91-0.15v0.69 c-1.86,0.15-2.25,0.39-2.16,2.43l0.51,13.83C20.85,19.29,21.24,19.53,23.25,19.71"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#FFFFFF"
    },
    d: "M36.54,15.72 c-0.21,2.88-2.37,4.92-5.52,4.92c-4.47,0-6.51-3.27-6.51-7.32c0-4.56,2.94-7.32,6.36-7.32c3.18,0,5.61,2.49,5.61,6.66v0.27h-9.03 v0.36c0,4.23,1.23,6.42,4.2,6.42c2.16,0,3.9-1.62,4.11-3.99H36.54z M27.48,12.15h6.27c-0.03-3.66-1.05-5.37-2.94-5.37 C28.71,6.78,27.66,8.73,27.48,12.15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#FFFFFF"
    },
    d: "M49.41,8.61 c-0.12,1.05-0.63,1.47-1.44,1.47c-0.93,0-1.47-0.69-1.29-1.62c0.12-0.63,0.06-1.41-0.99-1.41c-1.56,0-2.76,1.98-2.76,4.92v5.37 c0,2.04,0.39,2.25,2.49,2.4v0.66c-1.29-0.12-2.61-0.18-3.63-0.18h-0.21c-1.02,0-2.07,0.06-3.3,0.18v-0.66 c1.71-0.15,1.98-0.45,1.98-2.28V9.27c0-1.92-0.09-2.19-2.13-2.28V6.36c1.44-0.03,2.61-0.06,3.96-0.21h0.69v2.67 C43.41,7.05,44.67,6,46.56,6C48.78,6,49.59,7.29,49.41,8.61"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#FFFFFF"
    },
    d: "M61.8,15.72 c-0.18,3.06-2.25,4.92-5.13,4.92c-4.02,0-6.21-3.36-6.21-7.29c0-4.62,2.91-7.35,6.6-7.35c1.47,0,2.58,0.54,3.36,1.26l0.57-1.35 h0.51v5.1h-0.57c-0.54-2.85-1.68-4.23-3.75-4.23c-2.61,0-3.81,2.64-3.81,6.48c0,4.14,1.14,6.45,3.9,6.45 c1.86,0,3.54-1.44,3.75-3.99H61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#FFFFFF"
    },
    d: "M75.78,15.72 c-0.21,2.88-2.37,4.92-5.52,4.92c-4.47,0-6.51-3.27-6.51-7.32c0-4.56,2.94-7.32,6.36-7.32c3.18,0,5.61,2.49,5.61,6.66v0.27h-9.03 v0.36c0,4.23,1.23,6.42,4.2,6.42c2.16,0,3.9-1.62,4.11-3.99H75.78z M66.72,12.15h6.27c-0.03-3.66-1.05-5.37-2.94-5.37 C67.95,6.78,66.9,8.73,66.72,12.15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#FFFFFF"
    },
    d: "M92.1,19.62v0.63 c-1.44,0.03-2.61,0.06-3.96,0.21h-0.69v-2.61c-0.75,1.8-2.04,2.79-3.96,2.79c-3.12,0-5.7-2.55-5.7-7.32c0-4.56,2.94-7.32,5.97-7.32 c1.65,0,2.82,0.81,3.54,2.31V3.12c0-1.92-0.09-2.19-2.13-2.28V0.21c1.44-0.03,2.61-0.06,3.96-0.21h0.84v17.34 C89.97,19.26,90.06,19.53,92.1,19.62 M87.39,13.26c0-4.47-1.38-6.48-3.45-6.48c-2.19,0-3.21,2.34-3.21,6.48s1.11,6.45,3.33,6.45 C86.07,19.71,87.39,17.73,87.39,13.26"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#FFFFFF"
    },
    d: "M105.45,15.72 c-0.21,2.88-2.37,4.92-5.52,4.92c-4.47,0-6.51-3.27-6.51-7.32c0-4.56,2.94-7.32,6.36-7.32c3.18,0,5.61,2.49,5.61,6.66v0.27h-9.03 v0.36c0,4.23,1.23,6.42,4.2,6.42c2.16,0,3.9-1.62,4.11-3.99H105.45z M96.39,12.15h6.27c-0.03-3.66-1.05-5.37-2.94-5.37 C97.62,6.78,96.57,8.73,96.39,12.15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#FFFFFF"
    },
    d: "M117.69,16.5 c0,2.91-2.46,4.14-4.92,4.14c-1.71,0-3.06-0.51-3.99-1.35l-0.54,1.44h-0.51v-5.1h0.57c0.36,2.55,1.95,4.23,4.38,4.23 c2.04,0,3.03-1.02,3.03-2.37c0-1.44-1.08-1.98-2.58-2.58l-2.19-0.87c-2.01-0.78-3.18-2.13-3.18-4.08c0-2.64,2.34-3.96,4.62-3.96 c1.5,0,2.67,0.51,3.45,1.2l0.51-1.29h0.45v4.5h-0.57c-0.42-1.98-1.53-3.63-3.81-3.63c-1.65,0-2.67,0.9-2.67,2.16 c0,1.41,0.93,2.01,2.55,2.67l2.16,0.87C115.71,12.99,117.69,13.98,117.69,16.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.03,
    y: 11.19,
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#FFFFFF"
    },
    width: 6.81,
    height: 1.62
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#FFFFFF"
    },
    d: "M144.54,14.94 c0,3.3-2.82,5.4-6.75,5.4h-9.21v-0.69c2.04-0.09,2.4-0.36,2.4-2.37V3.36c0-2.01-0.36-2.28-2.4-2.37V0.3h7.89 c4.29,0,6.87,1.92,6.87,4.8c0,2.31-1.77,3.99-4.32,4.68v0.03C142.26,10.23,144.54,12.03,144.54,14.94 M133.95,1.17v8.37h1.89 c3.09,0,4.47-1.38,4.47-4.2c0-2.76-1.38-4.17-4.5-4.17H133.95z M141.33,14.94c0-3-1.44-4.53-4.29-4.53h-3.09v7.53 c0,0.99,0.12,1.53,1.89,1.53h1.2C139.89,19.47,141.33,17.97,141.33,14.94"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#FFFFFF"
    },
    d: "M158.82,15.72 c-0.21,2.88-2.37,4.92-5.52,4.92c-4.47,0-6.51-3.27-6.51-7.32c0-4.56,2.94-7.32,6.36-7.32c3.18,0,5.61,2.49,5.61,6.66v0.27h-9.03 v0.36c0,4.23,1.23,6.42,4.2,6.42c2.16,0,3.9-1.62,4.11-3.99H158.82z M149.76,12.15h6.27c-0.03-3.66-1.05-5.37-2.94-5.37 C150.99,6.78,149.94,8.73,149.76,12.15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#FFFFFF"
    },
    d: "M175.47,19.74v0.66 c-1.23-0.12-2.28-0.18-3.3-0.18h-0.09c-0.93,0-2.01,0.06-3.06,0.18v-0.66c1.47-0.15,1.8-0.36,1.8-2.28V9.69 c0-2.04-0.78-2.76-2.22-2.76c-1.83,0-3.39,1.59-3.39,3.78v6.75c0,1.92,0.36,2.13,1.83,2.28v0.66c-1.05-0.12-2.13-0.18-3.06-0.18 h-0.12c-1.02,0-2.07,0.06-3.3,0.18v-0.66c1.71-0.15,1.98-0.45,1.98-2.28V9.27c0-1.92-0.09-2.19-2.13-2.28V6.36 c1.44-0.03,2.61-0.06,3.96-0.21h0.69v2.34c0.66-1.5,2.16-2.49,4.14-2.49c2.76,0,4.29,1.71,4.29,4.59v6.87 C173.49,19.29,173.76,19.59,175.47,19.74"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#FFFFFF"
    },
    d: "M187.86,15.93 l-0.93,4.41h-10.56v-0.3l7.98-13.05h-2.52c-2.07,0-3.21,0.54-4.2,3.45h-0.66l0.9-4.17h9.81V6.6l-8.01,13.02h3.27 c1.92,0,3.27-0.57,4.26-3.69H187.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#1DA4E4"
    },
    d: "M214.41,19.65v0.66 c-0.66,0.21-1.62,0.3-2.55,0.3c-2.13,0-2.85-0.6-3.87-2.67l-1.95-3.99c-0.84-1.8-1.8-3.18-3.81-3.18h-1.08v6.42 c0,2.1,0.36,2.34,2.37,2.52v0.69c-2.22-0.15-2.58-0.18-3.81-0.18h-0.09c-1.23,0-1.59,0.03-3.81,0.18v-0.69 c2.01-0.18,2.37-0.42,2.37-2.52V3.36c0-2.01-0.36-2.28-2.4-2.37V0.3h8.04c4.68,0,7.26,1.89,7.26,5.04c0,3.03-2.43,4.8-6.03,5.16 v0.06c1.59,0.27,3.15,1.14,4.26,3.24l2.13,4.05C212.25,19.38,212.64,19.65,214.41,19.65 M201.15,1.17v8.7h2.1 c3.27,0,4.68-1.41,4.68-4.35c0-2.85-1.38-4.35-4.68-4.35H201.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#1DA4E4"
    },
    d: "M226.65,15.72 c-0.21,2.88-2.37,4.92-5.52,4.92c-4.47,0-6.51-3.27-6.51-7.32c0-4.56,2.94-7.32,6.36-7.32c3.18,0,5.61,2.49,5.61,6.66v0.27h-9.03 v0.36c0,4.23,1.23,6.42,4.2,6.42c2.16,0,3.9-1.62,4.11-3.99H226.65z M217.59,12.15h6.27c-0.03-3.66-1.05-5.37-2.94-5.37 C218.82,6.78,217.77,8.73,217.59,12.15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#1DA4E4"
    },
    d: "M243.3,19.74v0.66 c-1.23-0.12-2.28-0.18-3.3-0.18h-0.09c-0.93,0-2.01,0.06-3.06,0.18v-0.66c1.47-0.15,1.8-0.36,1.8-2.28V9.69 c0-2.04-0.78-2.76-2.22-2.76c-1.83,0-3.39,1.59-3.39,3.78v6.75c0,1.92,0.36,2.13,1.83,2.28v0.66c-1.05-0.12-2.13-0.18-3.06-0.18 h-0.12c-1.02,0-2.07,0.06-3.3,0.18v-0.66c1.71-0.15,1.98-0.45,1.98-2.28V9.27c0-1.92-0.09-2.19-2.13-2.28V6.36 c1.44-0.03,2.61-0.06,3.96-0.21h0.69v2.34c0.66-1.5,2.16-2.49,4.14-2.49c2.76,0,4.29,1.71,4.29,4.59v6.87 C241.32,19.29,241.59,19.59,243.3,19.74"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000147922539556591950790000012222324661796826790_)",
      fill: "#1DA4E4"
    },
    d: "M252.6,18.51v0.87 c-0.93,0.81-1.98,1.26-3.24,1.26c-2.01,0-3.18-1.23-3.18-3.87V7.2h-2.37V6.48c2.43-0.33,3.78-1.23,4.44-4.38h0.6v4.17h3.57V7.2 h-3.57v9.81c0,1.71,0.48,2.34,1.59,2.34C251.28,19.35,251.97,18.99,252.6,18.51"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMbRentLogoEinzeiligNeg);
export default __webpack_public_path__ + "static/media/MB-Rent-logo-einzeilig_neg.c9cc3153.svg";
export { ForwardRef as ReactComponent };